import isObject from 'lodash/isObject';

import { isNotEmptyString } from '../is-not-empty-string';

export const validateSetOptionsVisibilityRule = (optionsVisibility: {
	isVisible: boolean;
	options: string[];
}): boolean =>
	isObject(optionsVisibility) &&
	typeof optionsVisibility.isVisible === 'boolean' &&
	Array.isArray(optionsVisibility.options) &&
	optionsVisibility.options.every(isNotEmptyString);
